// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-11-10T09:33:29Z                      #

// ##############################################################

// @ts-ignore - not used import
import {AxiosInstance, AxiosResponse, AxiosRequestConfig, CancelToken} from 'axios';
// @ts-ignore - not used import
import {unwrapResponse, generateUrl, baseAxios} from '@mc/axios-api';
// @ts-ignore - not used import
import * as importUrl from 'url';
// @ts-ignore - not used import
import SigningResult from "./types/SigningResult";
// @ts-ignore - not used import
import ModuleCode from "./types/ModuleCode";
// @ts-ignore - not used import
import SigningStatus from "./types/SigningStatus";
// @ts-ignore - not used import
import SigningRequest from "./types/SigningRequest";
// @ts-ignore - not used import
import CertificateInfo from "./types/CertificateInfo";

// @ts-ignore - not used import
import * as UpdateMethods from "./UpdateMethods";


// @ts-ignore - not used import
type SimpleHeaders = {[key: string]: string};

/**
 * Api pro podepisování. Generated from cz.marbes.sign.SignApi.
 */
export default class SignApi {
    /**
     * Získání seznamu aktivních modulů.
     *
     * @return seznam modulů
     */
    static getActiveModules(config?: {cancelToken?: CancelToken}) : Promise<ModuleCode[]> {
        return unwrapResponse<ModuleCode[]>(SignApi.raw.getActiveModules(config));
    }
    /**
     * Získání seznamu certifikátů.
     *
     * @param requestId unikátní identifikátor pro získání certifikátů
     * @return seznam certifikátů
     */
    static getCertificates(requestId : string, config?: {cancelToken?: CancelToken}) : Promise<CertificateInfo[]> {
        return unwrapResponse<CertificateInfo[]>(SignApi.raw.getCertificates(requestId, config));
    }
    /**
     * Získání stavu průběhu podepisování.
     *
     * @param signingId unikátní identifikátor podepisování
     * @return stav průběhu podepisování
     */
    static statusSigning(signingId : string, config?: {cancelToken?: CancelToken}) : Promise<SigningStatus> {
        return unwrapResponse<SigningStatus>(SignApi.raw.statusSigning(signingId, config));
    }
    /**
     * Zahájení podepisování.
     *
     * @param signingRequest parametry podepisování
     * @return informace zahájeného podepisování
     */
    static startSigning(signingRequest : SigningRequest, config?: {cancelToken?: CancelToken}) : Promise<SigningResult> {
        return unwrapResponse<SigningResult>(SignApi.raw.startSigning(signingRequest, config));
    }
    /**
     * Zrušení probíhajícího podepisování.
     *
     * @param signingId unikátní identifikátor podepisování
     */
    static cancelSigning(signingId : string, config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(SignApi.raw.cancelSigning(signingId, config));
    }

    static raw = {
            getActiveModules: function(config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<ModuleCode[]>> {
                const uri = `/qsign/api/sign/modules/active`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<ModuleCode[]>>(finalUri, finalConfig);
            },
            getCertificates: function(requestId : string, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<CertificateInfo[]>> {
                const uri = `/qsign/api/sign/certificates`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = { requestId };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<CertificateInfo[]>>(finalUri, finalConfig);
            },
            statusSigning: function(signingId : string, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SigningStatus>> {
                const uri = `/qsign/api/sign/${signingId}`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.get<any, AxiosResponse<SigningStatus>>(finalUri, finalConfig);
            },
            startSigning: function(signingRequest : SigningRequest, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<SigningResult>> {
                const uri = `/qsign/api/sign/init`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<SigningResult>>(finalUri, UpdateMethods.updateSigningRequest_C85543(signingRequest), finalConfig);
            },
            cancelSigning: function(signingId : string, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/sign/${signingId}/cancel`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, 0, finalConfig);
            },
    }
}
